<mat-card class="subform-card">
  <mat-card-header>
    <mat-card-title class="form-group-title">
      {{ title | translate }}
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <ng-container [formGroup]="form">
      <div
        class="d-flex align-items-center gap-4 mb-4"
        *ngFor="let day of DAY"
        [ngClass]="!this.form.get(day)?.value ? 'padded-bottom' : ''"
      >
        <div class="label">
          {{ DAYS + day | uppercase | translate }}
        </div>
        <ng-container *ngIf="this.form.get(day)?.value.from">
          <app-time-picker
            class="padded-top"
            [formGroupName]="day"
            [hours]="hours"
          ></app-time-picker>
          <button
            type="button"
            class="small-pill-button"
            mat-raised-button
            color="warn"
            (click)="remove(day)"
          >
            <mat-icon>disabled_by_default</mat-icon>
          </button>
        </ng-container>
        <ng-container *ngIf="!this.form.get(day)?.value.from">
          <button
            type="button"
            class="small-pill-button"
            mat-raised-button
            color="primary"
            (click)="add(day)"
          >
            <mat-icon>add</mat-icon>
          </button>
        </ng-container>
      </div>
    </ng-container>
  </mat-card-content>
</mat-card>
